import { useCart } from "../context/CartContext";
import "./carrito.css";
import EmptyCartPopup from "./EmptyCartPopup";
import { useEffect } from "react";
import { DeleteCanSvg } from "./DeleteCanSvg";
const Carrito = () => {
  const {
    state: { carrito },
    dispatch,
  } = useCart();
  const totalValorCarrito = carrito.reduce(
    (total, item) => total + item.precio * item.quantity,
    0
  );
  const totalProductosCarrito = carrito.reduce(
    (total, item) => total + item.quantity,
    0
  );

  const pesoCarrito = carrito.reduce(
    (pesoTotal, item) => pesoTotal + (item.peso || 0) * item.quantity,
    0
  );

  const quitarProducto = (product) => {
    dispatch({ type: "REMOVE_FROM_CART", payload: product });
  };
  const formatearCartItem = (product) => {
    const presentacion = product.presentacion.toLowerCase().trim();

    // Buscamos número + unidad. Si no hay número, asumimos 1.
    const regex = /(?:(\d+(?:[\.,]\d+)?)\s*)?(kg|kilos|paquete|paquetes|lt)/i;
    const match = presentacion.match(regex);

    if (match) {
      const cantidad = match[1] ? parseFloat(match[1].replace(",", ".")) : 1;
      const unidad = match[2];

      if (unidad.startsWith("kg") || unidad.startsWith("kilo")) {
        return `${product.quantity * cantidad}kg`;
      }

      if (unidad.startsWith("paquete")) {
        const total = product.quantity * cantidad;
        return `${total} paquete${total !== 1 ? "s" : ""}`;
      }
    }

    const genericRegex = /(\d+(?:[\.,]\d+)?)\s+(.*)/;
    const genericMatch = presentacion.match(genericRegex);

    if (genericMatch) {
      const cantidadBase = parseFloat(genericMatch[1].replace(",", "."));
      const unidadBase = genericMatch[2];
      const total = product.quantity * cantidadBase;
      return `${total} ${unidadBase}`;
    }

    // Si no se encuentra número, repetir el string completo por cantidad
    return `${product.quantity} ${presentacion}`;
  };

  const enviarPedidoPorWhatsApp = () => {
    const mensaje = carrito
      .map(
        (producto) =>
          `-${producto.icono ? producto.icono + " " : ""}${
            producto.nombre
          } ${formatearCartItem(producto)}`
      )
      .join("\n");
    const mensajeCompleto = `Les envío mi pedido:\n${mensaje}`;

    const mensajeCodificado = encodeURIComponent(mensajeCompleto);
    const numeroTelefono = `5491169772073`;
    const esMovil =
      /Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Opera Mini|IEMobile|Mobile/i.test(
        navigator.userAgent
      );

    const urlWhatsApp = esMovil
      ? `https://api.whatsapp.com/send?phone=${numeroTelefono}&text=${mensajeCodificado}` // Abre la app en móvil
      : `https://web.whatsapp.com/send?phone=${numeroTelefono}&text=${mensajeCodificado}`; // Abre WhatsApp Web en escritorio

    // Abre la URL de WhatsApp en una nueva pestaña
    localStorage.removeItem("carrito");
    window.open(urlWhatsApp, "_blank");
    window.location.reload(); // Recarga la página actual
  };

  return (
    <>
      {/* Mostrar el popup si el carrito está vacío */}
      {carrito.length === 0 && (
        <>
          <div className="carritoVacio"></div>
          <EmptyCartPopup />
        </>
      )}

      {/* Mostrar el contenido del carrito solo si hay productos */}
      {carrito.length > 0 && (
        <>
          <div className="cartList">
            {carrito.map((product) => (
              <div className="cartProduct shadow text-center" key={product.id}>
                <div
                  className="product-image"
                  style={{ backgroundImage: `url(${product.img})` }}
                ></div>
                <div className="cartProductDetails">
                  <div className="cartProductName">{product.nombre}</div>
                  <p className="cartProductQuantity">
                    {formatearCartItem(product)}{" "}
                  </p>
                  <p className="cartProductPrice">
                    $ {product.quantity * product.precio}
                  </p>
                </div>
                <button
                  className="deleteProduct"
                  onClick={() => quitarProducto(product)}
                >
                  <DeleteCanSvg></DeleteCanSvg>
                </button>
              </div>
            ))}
          </div>

          <div className="resumenCompra">
            <div className="cartDetail">
              <span className="summary-text">
                <b>Precio aprox: ${totalValorCarrito}</b>
              </span>

              <span className="summary-text">
                {totalProductosCarrito} productos
              </span>
              <span className="summary-text">
                Peso aprox: {pesoCarrito / 1000} kg
              </span>
            </div>
            <button
              className="checkout-button"
              onClick={enviarPedidoPorWhatsApp}
            >
              Enviar por WhatsApp
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Carrito;
